import { ErrorCode } from '@kreart/shared';
import { makeErrorKeyResolver } from '@/lib/form/errorMessages';

export const errorKeyFor = makeErrorKeyResolver({
  [ErrorCode.NOT_FOUND]: 'projects.areas.errors.notFound',
  [ErrorCode.PROJECTS_NOT_FOUND]: 'projects.areas.errors.projectNotFound',
});
